import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ actionKey }) => {
  switch (actionKey) {
  case 1:
    return (
      <div className="text-center">Are you sure you want to delete the message?</div>
    );

  case 2:
    return (
      <div className="text-center">Are you sure you want to delete the ticket?</div>
    );

  case 3:
    return (
      <div className="text-center">Are you sure you want to close and lock the ticket?</div>
    );

  case 4:
    return (
      <div className="text-center">Are you sure you want to close the ticket?</div>
    );

  case 5:
    return (
      <div className="text-center">Are you sure you want to mark as spam and delete the ticket?</div>
    );

  default:
    return '';
  }
};

Body.propTypes = {
  actionKey: PropTypes.number,
};

export default Body;
